var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0012 0.335632C5.55886 0.335632 0.335693 5.5588 0.335693 12.0011C0.335693 17.8228 4.60103 22.6481 10.1789 23.5266V15.374H7.21553V12.0011H10.1789V9.43097C10.1789 6.50497 11.9207 4.89147 14.5842 4.89147C15.8605 4.89147 17.1975 5.11897 17.1975 5.11897V7.9878H15.7229C14.2762 7.9878 13.8235 8.88847 13.8235 9.8113V11.9988H17.0564L16.5395 15.3716H13.8235V23.5243C19.4014 22.6505 23.6667 17.824 23.6667 12.0011C23.6667 5.5588 18.4435 0.335632 12.0012 0.335632Z"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
